/* ============================================================
   MISSKOSIKAS · MOTOR DE LA ZONA NARRATIVA
   Vanilla JS + IntersectionObserver. Sin librerías.
   Todo el contenido ya está en el HTML: si esto falla, la
   página se lee entera igual (y Google la indexa igual).
   Peso objetivo: < 8 KB minificado.
   ============================================================ */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ==========================================================
     POLÍTICA MÓVIL PRIMERO
     El teléfono es la experiencia principal, y es el aparato con
     el procesador más lento y la batería más corta. Así que en
     móvil NO se monta nada que el móvil no vaya a ver:

       · Parallax de portada  -> fuera (el brief ya lo pedía)
       · Línea de puntada SVG -> fuera (su contenedor .mk-stitch
                                 está en display:none < 990 px,
                                 así que dibujarla era trabajo
                                 tirado en cada scroll)
       · Volteo de tarjetas   -> fuera (en móvil son acordeón)

     Resultado: en un teléfono no queda NI UN listener de scroll.
     Todo lo que sigue vivo son IntersectionObserver, que el
     navegador resuelve fuera del hilo principal.

     Lo que SÍ se mantiene en móvil, porque es contenido y no
     decoración: los fundidos, el scrollytelling de los 5 pasos,
     los puntos calientes y el comparador antes/después.
     ========================================================== */
  var movil = window.matchMedia('(max-width: 749px)').matches;

  var root = document.querySelector('[data-mk-narrative]');
  if (!root) return;

  /* Con movimiento reducido no montamos nada: el CSS ya deja
     todo visible y estático. El contenido manda. */
  if (reduce) {
    root.querySelectorAll('[data-mk-reveal], .mk-mask, .mk-quote, .mk-tabla').forEach(function (el) {
      el.classList.add('is-in');
    });
    initHotspots();   // esto sí: es interacción, no decoración
    initCompare();
    initFlipsTap();
    return;
  }

  /* ---------- utilidad: observar una vez ------------------- */
  function once(el, cb, ratio, margin) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        cb(e.target);
        io.unobserve(e.target);
      });
    }, { threshold: ratio || 0.15, rootMargin: margin || '0px 0px -8% 0px' });
    io.observe(el);
    return io;
  }

  /* ---------- 1. reveals escalonados ---------------------- */
  root.querySelectorAll('[data-mk-reveal]').forEach(function (el) {
    var i = parseInt(el.getAttribute('data-mk-reveal'), 10);
    if (i > 0) el.style.setProperty('--mk-delay', Math.min(i, 8) * 80 + 'ms'); // nunca > 80ms entre elementos
    once(el, function (t) { t.classList.add('is-in'); });
  });

  /* ---------- 2. máscaras de titular ---------------------- */
  root.querySelectorAll('.mk-mask').forEach(function (el, i) {
    el.style.setProperty('--mk-delay', i * 80 + 'ms');
    once(el, function (t) { t.classList.add('is-in'); }, 0.4);
  });

  /* ---------- 3. cita palabra a palabra ------------------- */
  root.querySelectorAll('.mk-quote').forEach(function (q) {
    if (!q.querySelector('w')) {
      var words = q.textContent.trim().split(/\s+/);
      q.textContent = '';
      words.forEach(function (w, i) {
        var el = document.createElement('w');
        el.textContent = w;
        el.style.setProperty('--mk-delay', i * 55 + 'ms');
        q.appendChild(el);
        if (i < words.length - 1) q.appendChild(document.createTextNode(' '));
      });
    }
    once(q, function (t) { t.classList.add('is-in'); }, 0.5);
  });

  /* ---------- 4. tabla comparativa ------------------------ */
  root.querySelectorAll('.mk-tabla').forEach(function (tabla) {
    tabla.querySelectorAll('tbody tr').forEach(function (tr, i) {
      tr.style.setProperty('--mk-delay', i * 60 + 'ms');
    });
    once(tabla, function (t) { t.classList.add('is-in'); }, 0.2);
  });

  /* ---------- 5. contadores ------------------------------- */
  root.querySelectorAll('[data-mk-count]').forEach(function (el) {
    var target = parseFloat(el.getAttribute('data-mk-count'));
    var suffix = el.getAttribute('data-mk-suffix') || '';
    once(el, function (t) {
      var start = null, dur = 900;
      function step(ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        t.textContent = Math.round(target * eased) + suffix;
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }, 0.6);
  });

  /* ---------- 6. parallax de portada (solo escritorio) ----- */
  (function () {
    if (movil) return;   // en teléfono, ni se registra el listener
    var img = root.querySelector('.mk-portada__media img');
    if (!img) return;
    var ticking = false;
    function update() {
      var y = window.scrollY;
      if (y < window.innerHeight * 1.2) {
        img.style.transform = 'translate3d(0,' + (y * 0.3) + 'px,0)'; // 30 % de la velocidad
      }
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  })();

  /* ---------- 7. índice lateral activo -------------------- */
  (function () {
    var links = root.querySelectorAll('.mk-toc a');
    if (!links.length) return;
    var map = {};
    links.forEach(function (a) {
      var id = a.getAttribute('href').replace('#', '');
      var sec = document.getElementById(id);
      if (sec) map[id] = { link: a, sec: sec };
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var item = map[e.target.id];
        if (!item) return;
        if (e.isIntersecting) {
          links.forEach(function (l) { l.classList.remove('is-active'); });
          item.link.classList.add('is-active');
        }
      });
    }, { rootMargin: '-30% 0px -55% 0px' });
    Object.keys(map).forEach(function (k) { io.observe(map[k].sec); });
  })();

  /* ---------- 8. scrollytelling de 5 pasos ---------------- */
  (function () {
    var wrap = root.querySelector('.mk-scrolly');
    if (!wrap) return;
    var imgs = wrap.querySelectorAll('.mk-scrolly__sticky img');
    var pasos = wrap.querySelectorAll('.mk-paso');
    if (!imgs.length || !pasos.length) return;
    imgs[0].classList.add('is-active');

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var i = parseInt(e.target.getAttribute('data-mk-paso'), 10) - 1;
        imgs.forEach(function (img, n) { img.classList.toggle('is-active', n === i); });
      });
    }, { rootMargin: '-45% 0px -45% 0px' });
    pasos.forEach(function (p) { io.observe(p); });

    /* Línea de puntada que se dibuja con el scroll.
       Su contenedor `.mk-stitch` está en `display: none` por debajo
       de 990 px, así que en móvil calcularla en cada scroll era
       trabajo tirado a la basura. Solo escritorio. */
    var stitch = movil ? null : wrap.querySelector('.mk-stitch path');
    if (stitch) {
      var len = stitch.getTotalLength();
      stitch.style.setProperty('--mk-stitch-offset', len);
      var col = wrap.querySelector('.mk-scrolly__pasos') || pasos[0].parentNode;
      var t2 = false;
      function draw() {
        var r = col.getBoundingClientRect();
        var p = (window.innerHeight * 0.65 - r.top) / r.height;
        p = Math.max(0, Math.min(1, p));
        stitch.style.setProperty('--mk-stitch-offset', len * (1 - p));
        t2 = false;
      }
      window.addEventListener('scroll', function () {
        if (!t2) { requestAnimationFrame(draw); t2 = true; }
      }, { passive: true });
      draw();
    }
  })();

  initHotspots();
  initCompare();
  initFlipsTap();

  /* ---------- 9. puntos calientes ------------------------- */
  function initHotspots() {
    document.querySelectorAll('.mk-hotspots').forEach(function (wrap) {
      var hots = wrap.querySelectorAll('.mk-hot');
      hots.forEach(function (btn) {
        var card = wrap.querySelector('#' + btn.getAttribute('aria-controls'));
        if (!card) return;
        /* la ficha se coloca junto a su punto */
        card.style.left = btn.style.left;
        card.style.top = 'calc(' + btn.style.top + ' + 42px)';
        btn.addEventListener('click', function () {
          var abrir = !card.classList.contains('is-open');
          wrap.querySelectorAll('.mk-hot__card').forEach(function (c) { c.classList.remove('is-open'); });
          wrap.querySelectorAll('.mk-hot').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
          if (abrir) { card.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); }
        });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        wrap.querySelectorAll('.mk-hot__card').forEach(function (c) { c.classList.remove('is-open'); });
        wrap.querySelectorAll('.mk-hot').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      });
    });
  }

  /* ---------- 10. comparador antes / después -------------- */
  function initCompare() {
    document.querySelectorAll('.mk-compare').forEach(function (box) {
      var range = box.querySelector('input[type="range"]');
      if (!range) return;
      function set(v) { box.style.setProperty('--mk-split', v + '%'); }
      set(range.value);
      range.addEventListener('input', function () { set(range.value); });
      /* arrastre directo sobre la imagen, además del range accesible */
      var dragging = false;
      function fromEvent(e) {
        var r = box.getBoundingClientRect();
        var x = (e.touches ? e.touches[0].clientX : e.clientX) - r.left;
        var v = Math.max(0, Math.min(100, (x / r.width) * 100));
        range.value = v; set(v);
      }
      box.addEventListener('pointerdown', function (e) { dragging = true; fromEvent(e); box.setPointerCapture(e.pointerId); });
      box.addEventListener('pointermove', function (e) { if (dragging) fromEvent(e); });
      box.addEventListener('pointerup', function () { dragging = false; });
      box.addEventListener('pointercancel', function () { dragging = false; });
    });
  }

  /* ---------- 11. volteo por tap (táctil) ----------------- */
  function initFlipsTap() {
    if (window.matchMedia('(hover: hover)').matches) return;
    if (window.matchMedia('(max-width: 749px)').matches) return; // en móvil es acordeón, no volteo
    document.querySelectorAll('.mk-flip').forEach(function (f) {
      f.addEventListener('click', function () { f.classList.toggle('is-flipped'); });
    });
  }
})();
